






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {BaseFretebasEmpresa} from '@/model/resource/BaseFretebasEmpresa'
import {InputBaseFretebasEmpresaSchema} from '@/schema/resource/BaseFretebasEmpresa/InputBaseFretebasEmpresaSchema'

@Component
export default class PersistBaseFretebasEmpresaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputBaseFretebasEmpresaSchema()
  baseFretebasEmpresa = new BaseFretebasEmpresa()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.baseFretebasEmpresa.getBaseFretebasEmpresa(id)
    }

    $.await.done('getBaseFretebasEmpresa')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.baseFretebasEmpresa.persistBaseFretebasEmpresa()
    await Helper.successAndPush(
      'system.success.persist',
      '/base-fretebas-empresa/list'
    )
  }
}
